import { InvoiceStatus, type Invoice } from './types'

export const mockInvoices: Invoice[] = [
  {
    id: 'inv-001',
    dateDue: '2026-01-31',
    type: 'INVOICE',
    amount: 1234.0,
    currency: 'USD',
    status: InvoiceStatus.UNPAID,
  },
  {
    id: 'inv-002',
    dateDue: '2025-12-31',
    type: 'INVOICE',
    amount: 1234.0,
    currency: 'USD',
    status: InvoiceStatus.PAID,
  },
  {
    id: 'inv-003',
    dateDue: '2025-11-30',
    type: 'INVOICE',
    amount: 1234.0,
    currency: 'USD',
    status: InvoiceStatus.PAID,
  },
  {
    id: 'inv-004',
    dateDue: '2025-10-31',
    type: 'INVOICE',
    amount: 1234.0,
    currency: 'USD',
    status: InvoiceStatus.PAID,
  },
]
